export default __webpack_public_path__ + "static/media/create_task.4aaf665e.svg";